import { render, staticRenderFns } from "./FullPageImagePanel.vue?vue&type=template&id=7196e20a"
import script from "./FullPageImagePanel.vue?vue&type=script&lang=ts"
export * from "./FullPageImagePanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports